import React, { Component } from "react";
class TabLink extends Component {
  constructor(props) {
    super(props);
    this.state = { tabstate: "0 " };
  }

  render() {
    const astyles = {
      textDecoration: "none",
      fontSize: "18px",
      lineHeight: "24px"
    };

    return (
      <li
        className="tabLink"
        style={{ listStyle: "none", margin: 0 }}
        tabIndex="-1"
      >
        <a
          id={this.props.id}
          href={this.props.url}
          className="tab"
          style={astyles}
          tabIndex={this.state.tabstate}
        >
          {this.props.label} {this.props.title}
        </a>
      </li>
    );
  }
}

export default TabLink;
